import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const isInvalidValue = (value: string | undefined | number): boolean => {
  return value === undefined || value === null || value === '';
};

export const fromToValidator: ValidatorFn = (
  form: AbstractControl
): ValidationErrors | null => {
  const from = form.get('from').value;
  const to = form.get('to').value;

  if (isInvalidValue(from) || isInvalidValue(to)) {
    return null;
  }

  return Number(from) >= Number(to) ? { invalidFromTo: true } : null;
};
